import { ConfigurationError, ValidationError } from '@cian/peperrors/shared';
import { System } from './sources/system.js';
import { Config, Matcher, validate } from '../shared/index.js';
import { SortedWritableSource } from '../shared/sources/index.js';
let setupConfigParams = null;
let config = null;
/**
 * @deprecated конфиг самоинициализируется, вызов этого метода можно удалить
 *
 * @export
 * @param {IBrowserConfigParams} params
 */
export function setup(params) {
    setupConfigParams = params;
}
export function init() {
    if (!config) {
        config = loadConfig();
    }
    return config;
}
export function getConfig() {
    if (!config) {
        throw new ConfigurationError({
            message: 'Config must be created before accessing it. Forgot to call init() before accessing config?',
            domain: 'config.getConfig',
        });
    }
    return config;
}
function initDump(projectName) {
    if (!window._cianConfig) {
        window._cianConfig = {};
    }
    const store = window._cianConfig;
    if (!store[projectName]) {
        store[projectName] = [];
    }
    const dump = store[projectName];
    if (!dump.watcher) {
        dump.watcher = document.createElement('span');
        dump.push = dumpPush;
        dump.concat = dumpConcat;
    }
    function dumpPush(...args) {
        const result = Array.prototype.push.apply(this, args);
        this.watcher?.dispatchEvent(new CustomEvent('update', { detail: this }));
        return result;
    }
    function dumpConcat(...args) {
        const result = Array.prototype.concat.apply(this, args);
        this.watcher?.dispatchEvent(new CustomEvent('update', { detail: result }));
        result.watcher = this.watcher;
        result.concat = dumpConcat;
        result.push = dumpPush;
        return result;
    }
    return dump;
}
function loadConfig() {
    const systemSource = new System(setupConfigParams);
    const matcher = new Matcher();
    const systemConfig = new Config({ source: systemSource, matcher });
    const projectName = systemConfig.getStrict('projectName');
    const dump = initDump(projectName);
    dump.forEach(setting => {
        if (!validate(setting)) {
            throw new ValidationError({
                message: `Received unexpected entry in _cianConfig.${projectName}`,
                domain: 'config.loadConfig',
                details: { setting: JSON.stringify(setting, null, 2) },
            });
        }
    });
    // TODO: Сейчас настройки передаются по ссылке, что небезопасно в случае микрофронтов
    const dumpSource = new SortedWritableSource(dump);
    // TODO: Для SPA-приложений нужно подумать об очистке подписок
    dump.watcher?.addEventListener('update', (e) => {
        dumpSource.add(e.detail);
    });
    const config = new Config({ source: [systemSource, dumpSource], matcher: new Matcher() });
    return config.attach({
        requestId: systemConfig.get('requestId') || undefined,
    });
}
//# sourceMappingURL=interface.js.map